// @flow

import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import { customValidators } from "../../utils/validators";
import useAsyncState from "../../hooks/useAsyncState";
import { updateOptins } from "../../actions/user";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import Button from "../atoms/Button";

const MarketingOptInForm = (): React.Node => {
    const dispatch = useDispatch();
    const [state, localActions] = useAsyncState();
    const { optIns } = useSelector((state: any): any => state.user);

    const handleFormSubmit = formData => {
        const newOptIns = [...optIns.optins];
        newOptIns.forEach(optIn => {
            optIn.is_optin = formData[optIn.id];
        });

        localActions.request();

        dispatch(updateOptins(newOptIns))
            .then(res => {
                localActions.success();
            })
            .catch((error: any) => {
                console.error(error);
                localActions.fail(
                    error.message ||
                        "There was an issue updating your notification and marketing preferences."
                );
            });
    };

    return (
        <ReactForm
            className="form-inset"
            validators={customValidators}
            onSuccess={handleFormSubmit}
        >
            <h3 className="login-profile-body__content__title">
                Email me about
            </h3>

            <ServerErrorMessage>{state.error}</ServerErrorMessage>

            {optIns && optIns.optins
                ? optIns.optins.map((optInOption: any, index: number) => {
                      return (
                          <ReactFormField
                              key={index}
                              type="checkbox"
                              label={optInOption.name}
                              name={optInOption.id}
                              defaultChecked={optInOption.is_optin}
                          />
                      );
                  })
                : null}

            <Button
                type="submit"
                styles={["green"]}
                inline={true}
                aria-label="Save"
                loading={state.loading}
                success={!!state.success}
            >
                Save
            </Button>
        </ReactForm>
    );
};

export default MarketingOptInForm;
